import { UserGroupClient } from '@frontend/group/api';
import type { GroupMember } from '@frontend/group/types';
import { UserClient } from '@frontend/user/api';
import type { IUser } from '@frontend/user/types';

const sortMembersByOrder = (members: GroupMember[]): GroupMember[] => [...members].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

/**
 * Fetches user-group members sorted by `order`, resolves them to users,
 * and returns users in that same member order (`resolveUsers` does not guarantee order).
 */
export const resolveUsersByGroupMemberOrder = async (groupId: string): Promise<IUser[]> => {
    const membersResponse = await UserGroupClient.fetchUserGroupMembers({
        group_id: groupId,
        sort_field: 'order',
        sort_direction: 'asc'
    });
    const orderedIds = sortMembersByOrder(membersResponse.results).map((member) => member.entity_id);
    if (orderedIds.length === 0) {
        return [];
    }

    const usersResponse = await UserClient.resolveUsers(orderedIds);
    const usersById = new Map(usersResponse.results.map((user) => [user.id, user]));

    return orderedIds.map((id) => usersById.get(id)).filter((user): user is IUser => !!user);
};
